import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b1a3f52"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-ellipsis-v" }, null, -1 /* HOISTED */));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-plus" }, null, -1 /* HOISTED */));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-brackets-curly" }, null, -1 /* HOISTED */));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-brackets-curly" }, null, -1 /* HOISTED */));
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from "element-plus";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { ref } from "vue";
import Button from "../../ui/Button.vue";
import DrawerTrigger from "../../ui/drawer/DrawerTrigger.vue";
import { useComponent } from "src/shared/store/component/composables";
import JsonDrawer from "../../ui/drawer/JsonDrawer.vue";
import CreateComponentSettingDialog from "../create-drawer/CreateComponentSettingDialog.vue";
import EditComponentSettingDrawer from "../edit-drawer/EditComponentSettingDrawer.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableToolbarKebabMenu',
    props: {
        componentId: {}
    },
    setup(__props) {
        const props = __props;
        const { component } = useComponent(() => props.componentId);
        const { builtComponent } = useBuiltComponent(() => props.componentId);
        const isDropdownVisible = ref(false);
        const showCreateSettingDialog = ref(false);
        const showEditDrawer = ref(false);
        const createdSettingName = ref("");
        const onVisibleChange = (visible) => {
            isDropdownVisible.value = visible;
        };
        const openCreateSettingDialog = () => {
            showCreateSettingDialog.value = true;
            isDropdownVisible.value = false;
        };
        const onSettingCreated = (settingName) => {
            showCreateSettingDialog.value = false;
            createdSettingName.value = settingName;
            showEditDrawer.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(ElDropdown), {
                    trigger: "click",
                    "hide-on-click": "",
                    "popper-class": "list list--drop-down list--drop-down--modern",
                    placement: "bottom-end",
                    onVisibleChange: onVisibleChange
                }, {
                    dropdown: _withCtx(() => [
                        _createVNode(_unref(ElDropdownMenu), null, {
                            default: _withCtx(() => [
                                (_unref(builtComponent))
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 0 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openCreateSettingDialog }, [
                                                        _hoisted_2,
                                                        _createTextVNode(" New Setting")
                                                    ])
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (_unref(component))
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 1 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_4,
                                                        _createTextVNode("JSON (Raw) ")
                                                    ], 8 /* PROPS */, _hoisted_3)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(JsonDrawer, {
                                                data: _unref(component),
                                                title: _unref(component).getDisplayName(),
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["data", "title", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (_unref(builtComponent))
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 2 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_6,
                                                        _createTextVNode("JSON (Built) ")
                                                    ], 8 /* PROPS */, _hoisted_5)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(JsonDrawer, {
                                                data: _unref(builtComponent),
                                                title: _unref(builtComponent).getDisplayName(),
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["data", "title", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(Button, {
                            shape: 'square',
                            level: 'menu',
                            "is-active": isDropdownVisible.value,
                            onClick: _cache[0] || (_cache[0] = ($event) => (isDropdownVisible.value = true))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_1
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["is-active"])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("div", null, [
                    (showCreateSettingDialog.value)
                        ? (_openBlock(), _createBlock(CreateComponentSettingDialog, {
                            key: 0,
                            "component-id": _ctx.componentId,
                            onClosed: _cache[1] || (_cache[1] = ($event) => (showCreateSettingDialog.value = false)),
                            onCreated: onSettingCreated
                        }, null, 8 /* PROPS */, ["component-id"]))
                        : _createCommentVNode("v-if", true),
                    (showEditDrawer.value)
                        ? (_openBlock(), _createBlock(EditComponentSettingDrawer, {
                            key: 1,
                            "component-id": _ctx.componentId,
                            "setting-name": createdSettingName.value,
                            onClosed: _cache[2] || (_cache[2] = ($event) => (showEditDrawer.value = false))
                        }, null, 8 /* PROPS */, ["component-id", "setting-name"]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
